/*
 * Sticky add to cart bar (custom, geïnspireerd op Palo Alto 9.x "cart-bar").
 * Toont zichzelf zodra het productformulier boven de viewport uit scrollt en
 * delegeert de klik naar de echte koopknop in [data-product-form].
 */
(function () {
  'use strict';

  if (customElements.get('cart-bar')) return;

  class CartBar extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-section-type="product-template"]');
      this.form = this.section && this.section.querySelector('[data-product-form]');
      if (!this.form) return;

      this.atcBtn = this.querySelector('[data-cart-bar-add-to-cart]');
      this.priceEl = this.querySelector('[data-cart-bar-price]');
      this.textEl = this.querySelector('[data-cart-bar-atc-text]');

      this.sizeWrap = this.querySelector('[data-cart-bar-sizes]');

      this.onClick = this.onClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSizeChange = this.onSizeChange.bind(this);
      this.resetButton = this.resetButton.bind(this);

      this.atcBtn.addEventListener('click', this.onClick);
      if (this.sizeWrap) this.sizeWrap.addEventListener('click', this.onSizeChange);
      document.addEventListener('theme:variant:change', this.onVariantChange);
      document.addEventListener('theme:cart:change', this.resetButton);

      // Trigger op de koopknop zelf, niet op het hele formulier: daar zit
      // (zeker mobiel) nog de dynamische checkout-knop onder, waardoor de
      // balk anders pas veel later verschijnt.
      // Mobiel verschijnt de balk al zodra de knop boven de helft van het
      // scherm uitkomt; desktop houdt een kleine marge van 120px aan.
      // Bij volledig uitverkochte producten is de koopknop-holder display:none
      // (en meldt de observer direct "uit beeld") — val dan terug op het
      // formulier zelf, daar staat ook de Klaviyo back-in-stock-knop.
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const earlyOffset = () => (isMobile ? window.innerHeight * 0.5 : 120);
      const realBtn = this.form.querySelector('[data-add-to-cart]');
      const realBtnVisible = realBtn && realBtn.offsetParent !== null;
      const trigger = realBtnVisible ? realBtn : this.form;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < earlyOffset();
          this.classList.toggle('is-visible', passed);
          this.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: isMobile ? '-50% 0px 0px 0px' : '-120px 0px 0px 0px' });
      this.observer.observe(trigger);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('theme:variant:change', this.onVariantChange);
      document.removeEventListener('theme:cart:change', this.resetButton);
    }

    onClick(event) {
      event.preventDefault();

      // Notify-modus (variant uitverkocht): open de Klaviyo back-in-stock-
      // modal via de door onsite.js geïnjecteerde trigger op de pagina.
      if (this.atcBtn.hasAttribute('data-cart-bar-notify')) {
        const bisTrigger = document.querySelector('.klaviyo-bis-trigger');
        if (bisTrigger) {
          bisTrigger.click();
        } else {
          this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      const realBtn = this.form.querySelector('[data-add-to-cart]');
      if (!realBtn || realBtn.hasAttribute('disabled')) return;

      this.atcBtn.classList.add('is-loading');
      this.atcBtn.setAttribute('disabled', '');

      if (this.form.requestSubmit) {
        this.form.requestSubmit(realBtn);
      } else {
        realBtn.click();
      }

      // Vangnet: het theme vuurt niet in elk pad een cart-event
      this.resetTimer = setTimeout(this.resetButton, 3000);
    }

    resetButton() {
      if (this.resetTimer) clearTimeout(this.resetTimer);
      this.atcBtn.classList.remove('is-loading');
      this.atcBtn.removeAttribute('disabled');
    }

    onSizeChange(event) {
      const btn = event.target.closest('[data-cart-bar-size-option]');
      if (!btn || btn.hasAttribute('disabled')) return;

      const value = btn.value;
      this.setActiveSize(value);

      const inputs = this.form.querySelectorAll('[data-single-option-selector]');
      const target = Array.prototype.find.call(inputs, (input) => input.value === value);
      if (!target) return;

      if (target.type === 'radio') {
        target.checked = true;
      } else {
        target.value = value;
      }
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setActiveSize(value) {
      if (!this.sizeWrap) return;
      this.sizeWrap.querySelectorAll('[data-cart-bar-size-option]').forEach((btn) => {
        btn.classList.toggle('is-current', btn.value === value);
      });
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      if (variant.option1) this.setActiveSize(variant.option1);

      if (this.priceEl && window.theme && typeof theme.formatMoney === 'function') {
        let html = '';
        if (variant.compare_at_price > variant.price) {
          html += '<s>' + theme.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</s> ';
        }
        html += theme.formatMoney(variant.price, theme.moneyFormat);
        this.priceEl.innerHTML = html;
      }

      // Wissel tussen koop- en notify-modus: uitverkochte variant krijgt
      // dezelfde "mail mij als ie terug is"-knop als op de productpagina.
      if (variant.available) {
        this.atcBtn.removeAttribute('data-cart-bar-notify');
        this.atcBtn.classList.remove('cart-bar__submit--notify');
        this.atcBtn.removeAttribute('disabled');
        if (this.textEl) this.textEl.textContent = this.atcBtn.getAttribute('data-label-add-to-cart');
      } else {
        this.atcBtn.setAttribute('data-cart-bar-notify', '');
        this.atcBtn.classList.add('cart-bar__submit--notify');
        this.atcBtn.removeAttribute('disabled');
        if (this.textEl) this.textEl.textContent = this.atcBtn.getAttribute('data-label-notify');
      }
    }
  }

  customElements.define('cart-bar', CartBar);
})();
